import { render, staticRenderFns } from "./BriqExpansionPanel.vue?vue&type=template&id=6f42de6a&scoped=true&lang=pug&"
import script from "./BriqExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./BriqExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./BriqExpansionPanel.vue?vue&type=style&index=0&id=6f42de6a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42de6a",
  null
  
)

export default component.exports